import React, { FC } from 'react'
import {
  Data,
  performDelete,
  performDeleteAll,
} from '../StandardComponents/OrderTable'
import Button from '@material-ui/core/Button'

import messages from '../../messages'
import ResponsiveModal, { ModalSizes } from '@src/components/ResponsiveModal'
import { Typography } from '@material-ui/core'
import {
  ResponsiveModalActions,
  ResponsiveModalBody,
} from '@src/components/ResponsiveModal/ResponsiveModal'
interface DeleteAllDialogProps {
  dialogOpen: boolean
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
  type: string
  selectedItem?: Data
  onDelete: any
}

let titleMsg = ''
let msg = ''
let buttonText = ''

const DeleteAllDialog: FC<DeleteAllDialogProps> = ({
  dialogOpen,
  setDialogOpen,
  type,
  selectedItem,
  onDelete,
}) => {
  const handleClose = () => {
    setDialogOpen(false)
  }
  if (type === 'All') {
    titleMsg = messages.CONF_DELETE_ALL_ITEM_DNA_PLATES.defaultMessage
    msg = messages.CONF_DELETE_ALL_ITEM_MSG_DNA_PLATES.defaultMessage
    buttonText = messages.CONF_DELETE_ALL_BUTTON_TEXT_DNA_PLATES.defaultMessage
  } else if (type === 'Selected' || type === 'SelectedWell') {
    titleMsg = messages.CONF_DELETE_ITEM_DNA_PLATES.defaultMessage
    msg = messages.CONF_DELETE_ITEM_MSG_DNA_PLATES.defaultMessage
    buttonText = messages.CONF_DELETE_BUTTON_TEXT_DNA_PLATES.defaultMessage
  }
  const handleDelete = () => {
    if (type === 'Selected') {
      performDelete(selectedItem)
      onDelete(selectedItem, type)
      setDialogOpen(false)
    } else if (type === 'All') {
      performDeleteAll()
      onDelete(selectedItem, type)
      setDialogOpen(false)
    } else if (type === 'SelectedWell') {
      onDelete(selectedItem, type)
      setDialogOpen(false)
    }
  }

  return (
    <ResponsiveModal
      open={dialogOpen}
      onClose={handleClose}
      size={ModalSizes.Small}
      renderTitle={() => (
        <Typography variant="h2" component="h2">
          {titleMsg}
        </Typography>
      )}
    >
      <ResponsiveModalBody>
        {msg}
        <ResponsiveModalActions>
          <Button
            onClick={handleClose}
            color="primary"
            id="delete-cancel-button"
            data-testid="delete-cancel-button"
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            onClick={handleDelete}
            color="primary"
            variant="contained"
            id="delete-confirm-button"
            data-testid="delete-confirm-button"
          >
            {buttonText}
          </Button>
        </ResponsiveModalActions>
      </ResponsiveModalBody>
    </ResponsiveModal>
  )
}

export default DeleteAllDialog
